export default __webpack_public_path__ + "static/media/washing-machine.dc54e863.svg";